'use-strict'

export default {
    SET_AUTHORIZED_USER: '@@auth/SET_AUTHORIZED_USER',
    LOGOUT: '@@auth/LOGOUT',
}